const ready = require("%helpers%/document-ready.js");

ready(function() {

	const scriptsUrls = [
		"planet-data/three.min.js",
		"planet-data/threex.planets.js",
		"planet-data/threex.atmospherematerial.js",
		"planet-data/customControls.js",
		"planet-data/TrackballControls.js",
		"planet-data/dat.gui.min.js",
		"planet-data/threex.atmospheredatgui.js",
		"planet-data/init.js"
	];
	const isDesktop = $(window).width() > 991;
	const $prices = $(".results");
	const $servicesMars = $(".services__mars");
	const pricesOffset = $prices.offset().top;
	const windowHeight = $(window).height() / 3 * 2;
	let curOffest = $(window).scrollTop();
	let flagCheckOffset = true;
	let scriptPosition = 0;

	// -- Functions BEGIN
	const loadScripts = () => {
		const scriptTag = document.createElement("script");

		scriptTag.onload = function () {
			if (scriptPosition < scriptsUrls.length) loadScripts();
			else if (scriptPosition = scriptsUrls.length) {
				$servicesMars.addClass("services__mars_visible");
			}
			scriptPosition++;
		};

		scriptTag.src = scriptsUrls[scriptPosition];
		document.head.appendChild(scriptTag);
	};

	const checkOffset = () => {
		curOffest = $(window).scrollTop() + windowHeight;

		if (curOffest >= pricesOffset) {
			flagCheckOffset = false;
			loadScripts();
		}
	};

	const setEventOnWindow = () => { 
		document.addEventListener("scroll", function () {
			if (flagCheckOffset) checkOffset();
		}, {passive: true});
	};
	// -- Functions END 

	if ( $prices.length && isDesktop ) setEventOnWindow(); 

});
